module.exports = __webpack_public_path__ + "img/facebook.cbd214ac.svg";